export const getBase64 = (img: Blob, callback: (result: string | ArrayBuffer | null) => void): void => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
